import { createSlice } from '@reduxjs/toolkit'
import {
  commonInitialState,
  commonReducers,
  createCommonThunks
} from '../commonSlice';

const initialState = {
  ...commonInitialState
}

const alarms = createSlice({
  name: 'alarms',
  initialState,
  reducers: { ...commonReducers }
})

export const { actions } = alarms.actions

export default alarms.reducer

// Operations
const thunks = createCommonThunks('alarms', '/alarm');

export const {
  fetchAll,
  fetchOne,
  createEntity,
  modifyEntity,
  deleteEntity,
} = thunks;
